import React from 'react';
import PropTypes from 'prop-types';

import withData from 'components/withData';

import { SettingsOptionsContext } from './';

class Provider extends React.Component {
	static propTypes = {
		children: PropTypes.node.isRequired,
		response: PropTypes.shape({
			loading: PropTypes.bool,
			data: PropTypes.any,
			refetch: PropTypes.func,
		}),
	};

	state = {
		options: null,
	};

	componentWillReceiveProps(nextProps) {
		const { response } = nextProps;

		if (response.success && !this.props.response.success) {
			this.setState({
				options: response.data,
			});
		}
	}

	render() {
		return (
			<SettingsOptionsContext.Provider
				value={{ ...this.state, refetch: this.props.response.refetch }}
			>
				{this.state.options || this.props.response.success
					? this.props.children
					: null}
			</SettingsOptionsContext.Provider>
		);
	}
}

export const SettingsOptionsContextProvider = withData(
	'/spend/overview/settings'
)(Provider);
